import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import './navigation-controls.less';

const NavigationControls = ({ onPrev, onNext, disabledPrev, disabledNext }) => {
  const classNames = useClassName('ParkScreenNavigationControls');

  return (
    <div className={classNames('container')}>
      <button
        className={classNames(['arrow', 'prev', disabledPrev && 'disabled'])}
        onClick={onPrev}
        disabled={disabledPrev}
        aria-label="Previous slide">
        {' '}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M30 20H9.16666M9.16666 20L19.1667 10M9.16666 20L19.1667 30"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        className={classNames(['arrow', 'next', disabledNext && 'disabled'])}
        onClick={onNext}
        disabled={disabledNext}
        aria-label="Next slide">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none">
          <path
            d="M10 20H30.8334M30.8334 20L20.8334 10M30.8334 20L20.8334 30"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

NavigationControls.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  disabledPrev: PropTypes.bool,
  disabledNext: PropTypes.bool,
};

NavigationControls.defaultProps = {
  disabledPrev: false,
  disabledNext: false,
};

export default NavigationControls;
